import axios from 'axios'
import store from '@/store'
import VueSimpleAlert from "vue-simple-alert";

import { getAuthBasic } from '@/utils/auth'
// create an axios instance
const serviceRawBasic = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 50000 // request timeout
})

// request interceptor
serviceRawBasic.interceptors.request.use(
    config => {
        // do something before request is sent
        config.headers['Content-Type'] = 'application/json'

        config.headers['Authorization'] = getAuthBasic()

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
serviceRawBasic.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // const res = response
        // if the custom code is not 20000, it is judged as an error.

        if (res.status !== 200) {
            var errorMsg = res.msg

            if (res.status === 401) {
                store.dispatch('login/resetToken').then(() => {
                    window.location.href = (process.env.BASE_URL) ? process.env.BASE_URL : '/'
                })
            } else {
                if (errorMsg !== undefined && !isSilent(response.config)) {
                    // this.$fire({
                    //     title: "Title",
                    //     text: "text",
                    //     type: "success",
                    //     timer: 3000
                    // }).then(r => {
                    //     console.log(r.value);
                    // });
                    VueSimpleAlert.fire({
                        title: "Error",
                        text: errorMsg.replace(/<br\s*\/?>/gi, '\n'),
                        type: "error",
                        timer: 3000
                    }).then(r => {
                        //after click or after timer
                        // console.log("r.value", r.value);//button value
                    });
                    // alert(errorMsg.replace(/<br\s*\/?>/gi, '\n') || 'Error')
                }
            }

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.status === 50008 || res.status === 50012 || res.status === 50014) {
                // to re-login

                store.dispatch('login/resetToken').then(() => {
                    location.reload()
                })
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        const errorMsg = error.response.data.msg
        // console.log(error) // for debug

        if (error.response.data.status === 401) {
            store.dispatch('login/resetToken').then(() => {
                window.location.href = (process.env.BASE_URL) ? process.env.BASE_URL : '/'
            })
        } else {
            if (errorMsg !== undefined && (!error.config || !error.config.silent)) {
                VueSimpleAlert.fire({
                    title: "Error",
                    text: errorMsg.replace(/<br\s*\/?>/gi, '\n'),
                    type: "error",
                    timer: 3000
                }).then(r => {
                    //after click or after timer
                    // console.log("r.value", r.value);//button value
                });
                // VueSimpleAlert.alert("Alert Message.");
                // alert(errorMsg.replace(/<br\s*\/?>/gi, '\n'))
            }
        }

        return Promise.reject(error)
    }
)

export default serviceRawBasic

function isSilent(config) {
    return !!(config && config.silent)
}



// WEBPACK FOOTER //
// ./src/utils/requestRawBasic.js